/**
 * AlmadarPostLearningFromInterruptionsSLPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostLearningFromInterruptionsSLPostPage
 */

import { useAlmadarPostLearningFromInterruptionsSLPostPageLogic } from '@/hooks/traits/useAlmadarPostLearningFromInterruptionsSLPostPageLogic';
import type { AlmadarPostLearningFromInterruptionsSLPostPageConfig } from '@/hooks/traits/useAlmadarPostLearningFromInterruptionsSLPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostLearningFromInterruptionsSLPostView as AlmadarPostLearningFromInterruptionsSLPostViewEntity } from '@app/shared';
import { Box } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { AlmadarPostLearningFromInterruptionsSLPostView } from '@/components/traits/AlmadarPostLearningFromInterruptionsSLPostView';
import { Container } from '@almadar/ui/components';
import { AlmadarPostLearningFromInterruptionsSLPostFooterView } from '@/components/traits/AlmadarPostLearningFromInterruptionsSLPostFooterView';
import { AlmadarPostLearningFromInterruptionsSLPostHeaderView } from '@/components/traits/AlmadarPostLearningFromInterruptionsSLPostHeaderView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostLearningFromInterruptionsSLPostPageViewProps {
  config?: Partial<AlmadarPostLearningFromInterruptionsSLPostPageConfig>;
}

export function AlmadarPostLearningFromInterruptionsSLPostPageView({ config: propsConfig }: AlmadarPostLearningFromInterruptionsSLPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostLearningFromInterruptionsSLPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostLearningFromInterruptionsSLPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostLearningFromInterruptionsSL" trait="AlmadarPostLearningFromInterruptionsSLPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostLearningFromInterruptionsSLPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostLearningFromInterruptionsSLPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box paddingY="xl" fullWidth={true} bg="transparent"><Container padding="lg" maxWidth="xl" size="xl"><AlmadarPostLearningFromInterruptionsSLPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostLearningFromInterruptionsSLPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostLearningFromInterruptionsSLPostPageView;
